import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { DialogLayoutService } from '../dialog-layout.service';
import { TranslationKeyMap } from '../focus-selector.i18n';
import { FocusSelectorState } from '../focus-selector.state';
import { FocusSelectorDialogData } from '../model/focus-selector-dialog-data.model';
import { FocusSelectorFocusModel } from '../model/focus-selector-focus.model';
import { FocusSelectorGoalModel } from '../model/focus-selector-goal.model';
import { FocusSelectorMetricModel } from '../model/focus-selector-metric.model';
import { FocusSelectorTriggerSource } from '../model/focus-selector-trigger-source.enum';

@Component({
    selector: 'cmps-focus-selection-result',
    templateUrl: './focus-selection-result.component.html',
    host: {
        class: 'cmps-focus-selection-result',
        '[class.force-column]': '_forceColumn',
    },
})
@TakeUntilDestroy()
export class FocusSelectionResultComponent
    implements OnInit, OnChanges, OnDestroy
{
    state: FocusSelectorState;

    @Input() dialogOptions: FocusSelectorDialogData;
    @Input() activeMetric: FocusSelectorMetricModel;
    @Input() selectedFocus: FocusSelectorFocusModel;
    @Input() selectedGoals: FocusSelectorGoalModel[];
    @Input() triggerSource: FocusSelectorTriggerSource;
    @Output() editSelectedMetric: EventEmitter<void>;
    @Output() deselectLoadedGoal: EventEmitter<
        FocusSelectorGoalModel['metricId']
    >;

    @Output() confirmSelection: EventEmitter<void>;
    @Output() scrollToGoal: EventEmitter<FocusSelectorGoalModel['metricId']>;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _forceColumn: boolean;
    /** @private */ _isDisabled: boolean;
    /** @private */ _TriggerSource = FocusSelectorTriggerSource;

    constructor(private readonly _dialogLayoutService: DialogLayoutService) {
        this._forceColumn = false;
        this._isDisabled = true;
        this.selectedGoals = [];
        this.editSelectedMetric = new EventEmitter<void>();
        this.deselectLoadedGoal = new EventEmitter<
            FocusSelectorGoalModel['metricId']
        >();
        this.confirmSelection = new EventEmitter<void>();
        this.scrollToGoal = new EventEmitter<
            FocusSelectorGoalModel['metricId']
        >();
    }

    ngOnInit(): void {
        this._dialogLayoutService.forceColumn
            .pipe(takeUntilDestroy(this))
            .subscribe((forceColumn) => {
                this._forceColumn = forceColumn;
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedFocus != null) {
            this._isDisabled =
                this.selectedFocus?.behaviour?.id == null ||
                this.selectedFocus?.subBehaviour?.id == null;
        }
    }

    ngOnDestroy(): void {
        this.editSelectedMetric.complete();
        this.deselectLoadedGoal.complete();
        this.confirmSelection.complete();
    }
}
